// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RKjAhRGaSEYfBF90MV28{box-sizing:border-box;background:var(--background-neutral-subtle);border-radius:6px;justify-content:space-between;align-items:center;height:40px;margin-bottom:3px;padding:8px 2px 8px 12px;display:flex}.RKjAhRGaSEYfBF90MV28:last-of-type{margin-bottom:0}.kIBWV7UC7zMrRwSW6JKE{align-items:center;display:flex}.C2rKininYpk42EhvXB6d{margin-right:7px}.bkjlIqTXis_wJ_IRcjx6{margin-left:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `RKjAhRGaSEYfBF90MV28`,
	"card__box": `kIBWV7UC7zMrRwSW6JKE`,
	"cardBox": `kIBWV7UC7zMrRwSW6JKE`,
	"card__avatar": `C2rKininYpk42EhvXB6d`,
	"cardAvatar": `C2rKininYpk42EhvXB6d`,
	"card__delete": `bkjlIqTXis_wJ_IRcjx6`,
	"cardDelete": `bkjlIqTXis_wJ_IRcjx6`
};
export default ___CSS_LOADER_EXPORT___;
